import React from 'react'

export const CustomForm = () => (
    <form className='custom-form'>
        <label>label:</label>
        <input type="text" name='label' />
        <label>Width:</label>
        <input type="text" name='width' />
        <label>type:</label>
        <input type="text" name='type' />
    </form>
);